import React from "react";
import PropTypes from "prop-types";
import _ from "lodash"

import UncheckedCheckBoxIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import ClearIcon from "@material-ui/icons/Clear"
import {Button,CustomInput} from ".."
import {
    withStyles,
    Input,
    InputAdornment,
    IconButton,
} from "@material-ui/core";


class CheckBoxChoiceQuestion extends React.Component{

    handleDeleteOption=(key)=>{
        const {onOptionDelete} = this.props;

        onOptionDelete?onOptionDelete(key):null;

    }

    addOption=()=>{

        const {onOptionAdd} = this.props;
        onOptionAdd?onOptionAdd():null;
    }

    optionValueChange=(event,index)=>{
        const {onOptionValueChange} = this.props;
        onOptionValueChange?onOptionValueChange(event,index):null
    }




    render(){

        const {classes,options,disabled,promptInputProps} = this.props
        console.log(disabled)
        return(
            <div className={classes.root}>
                <div>
                    <CustomInput
                        disabled={disabled}
                        labelText="Question Prompt"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={promptInputProps}

                    />


                        {disabled?
                                    <div> 
                                        <div style={{color:"rgba(0, 0, 0, 0.54)",marginTop:20}}>Options</div>
                                    </div>:<div/>}

                    {_.map(options,(option,key)=> {
                        return(<div key={key} className={classes.option}>

                            <Input
                                style={{paddingBottom:10}}
                                disabled={disabled}
                                placeholder={`Option ${key}`}
                                defaultValue={option}
                                className={classes.input}
                                inputProps={{
                                    'aria-label': 'Mutliple Choice Option',
                                }}
                                onChange={(event)=>{this.optionValueChange(event,key)}}

                                startAdornment={
                                    <InputAdornment position="end">
                                        <UncheckedCheckBoxIcon style={{paddingRight:10}} color="primary"/>
                                    </InputAdornment>
                                }


                                endAdornment={
                                    <InputAdornment position="end">
                                        {!disabled?<IconButton
                                            disabled={disabled}
                                            style={{color:"#ff4c4c"}}
                                            aria-label="Delete Option"
                                            onClick={() => {
                                                this.handleDeleteOption(key)
                                            }}
                                        >
                                            <ClearIcon/>
                                        </IconButton>:<div/>}
                                    </InputAdornment>
                                }
                            />
                        </div>)
                    })
                  }
                    <div style={{marginTop:20}}>
                        {!disabled?<Button color="primary" onClick={this.addOption} >
                            Add Option
                        </Button>:<div/>}
                    </div>
                </div>
            </div>

        )



    }

}

const styles={
    option:{
        display:"flex",
        flexDirection:"row",
        margin:10,
        padding: 20,
        paddingBottom:0,
        marginBottom:0
    }
}



export default withStyles(styles)(CheckBoxChoiceQuestion);


// WEBPACK FOOTER //
// ./src/components/QuestionTypes/CheckBoxChoiceQuestion.jsx